import { GiftCardTransactionDetailModel } from "src/models/GiftCardTransactionDetailModel";
import { api } from "../config/AxiosConfig";
import { ReportRequest } from "src/models/ReportRequest";
import { ReportResult, Result } from "src/models/ReportResult";
import { GiftCardTransactionDetailSummaryModel } from "src/models/GiftCardTransactionDetailSummaryModel";
import { API_ROOT } from "./ApiUrlFormatter";
import { ProgramSummaryDetailModel } from "src/models/ProgramSummaryDetailModel";
import { ProgramSummaryDetailSummaryModel } from "src/models/ProgramSummaryDetailSummaryModel";
import { MerchantSettlementTransactionDetailModel } from "src/models/MerchantSettlementTransactionDetailModel";
import { MerchantTransactionSummaryModel } from "src/models/MerchantTransactionSummaryModel";
import { TransactionSummaryModel } from "src/models/TransactionSummaryModel";
import { TransactionSummaryDetailModel } from "src/models/TransactionSummaryDetailModel";
import { MasterCardSettlementReconciliationModel } from "src/models/MasterCardSettlementReconciliationModel";
import { MasterCardSettlementReconciliationSummaryModel } from "src/models/MasterCardSettlementReconciliationSummaryModel";
import { TrialBalanceHistoricalDataModel } from "src/models/TrialBalanceHistoricalDataModel";
import { VisaSettlementReconciliationModel } from "src/models/VisaSettlementReconciliationModel";
import { VisaSettlementReconciliationSummaryModel } from "src/models/VisaSettlementReconciliationSummaryModel";
import { CardDefundingTransactionDetailModel } from "src/models/CardDefundingTransactionDetailModel";
import { CardDefundingTransactionDetailSummaryModel } from "src/models/CardDefundingTransactionDetailSummaryModel";
import { PulseSettlementReconciliationModel } from "src/models/PulseSettlementReconciliationModel";
import { PulseSettlementReconciliationSummaryModel } from "src/models/PulseSettlementReconciliationSummaryModel";
import { CardholderLiabilityDataModel } from "src/models/CardholderLiabilityDataModel";
import { MastercardFeeSummaryDetailModel } from "src/models/MastercardFeeSummaryDetailModel";
import { MastercardFeeSummaryModel } from "src/models/MastercardFeeSummaryModel";
import { CardholderFeeSummaryDetailModel } from "src/models/CardholderFeeSummaryDetailModel";
import { CardholderFeeSummaryModel } from "src/models/CardholderFeeSummaryModel";
import { CardAdjustmentModel } from "src/models/CardAdjustmentModel";
import { CardAdjustmentSummaryModel } from "src/models/CardAdjustmentSummaryModel";
import { MastercardInterchangeIncomeSummaryDetailModel } from "../../models/MastercardInterchangeIncomeSummaryDetailModel";
import { MastercardInterchangeIncomeSummaryModel } from "../../models/MastercardInterchangeIncomeSummaryModel";
import { CrossBinTransferSummaryModel } from "../../models/CrossBinTransferSummaryModel";
import { CrossBinTransferDetailModel } from "../../models/CrossBinTransferDetailModel";
import { CrossBinTransferDetailSummaryModel } from "../../models/CrossBinTransferDetailSummaryModel";
import { DeclinedAuthorizationRequestModel } from "../../models/DeclinedAuthorizationRequestModel";
import { MonthlyDeclinedTransactionsModel } from "../../models/MonthlyDeclinedTransactionsModel";



export const ReportApi = {  

  getGiftCardTransactionDetails: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<ReportResult<GiftCardTransactionDetailModel, GiftCardTransactionDetailSummaryModel>>(
      `${API_ROOT}/reporthub/reports/giftcardtransactiondetails`,
      reportRequest
    );
    return response;
  },

  exportGiftCardTransactionDetails: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/giftcardtransactiondetails/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getProgramSummaryDetail: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<ReportResult<ProgramSummaryDetailModel, ProgramSummaryDetailSummaryModel>>(
      `${API_ROOT}/reporthub/reports/programsummarydetail`,
      reportRequest
    );
    return response;
  },

  exportProgramSummaryDetails: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/programsummarydetail/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getMerchantSettlementTransactionDetail: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<ReportResult<MerchantSettlementTransactionDetailModel, MerchantTransactionSummaryModel>>(
      `${API_ROOT}/reporthub/reports/merchantsettlementtransactiondetail`,
      reportRequest
    );
    return response;
  },

  exportMerchantSettlementTransactionDetails: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/merchantsettlementtransactiondetail/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getTransactionSummary: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<ReportResult<TransactionSummaryModel, TransactionSummaryDetailModel>>(
      `${API_ROOT}/reporthub/reports/transactionsummary`,
      reportRequest
    );
    return response;
  },

  exportTransactionSummary: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/transactionsummary/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getMasterCardSettlementReconciliation: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<ReportResult<MasterCardSettlementReconciliationModel, MasterCardSettlementReconciliationSummaryModel>>(
      `${API_ROOT}/reporthub/reports/mastercardsettlementreconciliation`,
      reportRequest
    );
    return response;
  },

  exportMasterCardSettlementReconciliation: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/mastercardsettlementreconciliation/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getTrialBalanceHistoricalData: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<Result<TrialBalanceHistoricalDataModel>>(
      `${API_ROOT}/reporthub/reports/trialbalancehistoricaldata`,
      reportRequest
    );
    return response;
  },

  exportTrialBalanceHistoricalData: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/trialbalancehistoricaldata/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getVisaSettlementReconciliation: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<ReportResult<VisaSettlementReconciliationModel, VisaSettlementReconciliationSummaryModel>>(
      `${API_ROOT}/reporthub/reports/visasettlementreconciliation`,
      reportRequest
    );
    return response;
  },

  exportVisaSettlementReconciliation: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/visasettlementreconciliation/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getCardDefundingTransactionDetails: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post<
      ReportResult<CardDefundingTransactionDetailModel, CardDefundingTransactionDetailSummaryModel>
    >(`${API_ROOT}/reporthub/reports/carddefundingtransactiondetails`, reportRequest);
    return response;
  },

  exportCardDefundingTransactionDetails: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/carddefundingtransactiondetails/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob",
      }
    );
    return response;
  },

  
  getPulseSettlementReconciliation: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post<
      ReportResult<PulseSettlementReconciliationModel, PulseSettlementReconciliationSummaryModel>
    >(`${API_ROOT}/reporthub/reports/pulsesettlementreconciliation`, reportRequest);
    return response;
  },
  exportPulseSettlementReconciliation: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/pulsesettlementreconciliation/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob",
      }
    );
    return response;
  },

  getCardholderLiability: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post<Result<CardholderLiabilityDataModel>>(
      `${API_ROOT}/reporthub/reports/cardholderliability`,
      reportRequest
    );
    return response;
  },

  exportCardholderLiability: async (
    reportRequest:ReportRequest
  ) => {    
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/cardholderliability/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob"
      }
    );
    return response;
  },

  getMastercardFeeSummary: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post<ReportResult<MastercardFeeSummaryDetailModel, MastercardFeeSummaryModel>>(
      `${API_ROOT}/reporthub/reports/mastercardfeesummary`, 
      reportRequest
    );
    return response;
  },

  exportMastercardFeeSummary: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/mastercardfeesummary/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob",
      }
    );
    return response;
  },

  getCardholderFeeSummary: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post<ReportResult<CardholderFeeSummaryDetailModel, CardholderFeeSummaryModel>>(
      `${API_ROOT}/reporthub/reports/cardholderfeesummary`,
      reportRequest
    );
    return response;
  },

  exportCardholderFeeSummary: async (
    reportRequest: ReportRequest
  ) => {
    const response = await api.post(
      `${API_ROOT}/reporthub/reports/cardholderfeesummary/export`,
      reportRequest,
      {
        headers: {
          Accept: "text/csv",
        },
        responseType: "blob",
      }
    );
    return response;
  },

  getCardAdjustment: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post<ReportResult<CardAdjustmentModel, CardAdjustmentSummaryModel >>(
          `${API_ROOT}/reporthub/reports/cardadjustment`,
          reportRequest
      );
      return response;
  },

  exportCardAdjustment: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post(
          `${API_ROOT}/reporthub/reports/cardadjustment/export`,
          reportRequest,
          {
              headers: {
                  Accept: "text/csv",
              },
              responseType: "blob",
          }
      );
      return response;
  },

  getMastercardInterchangeIncomeSummary: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post<ReportResult<MastercardInterchangeIncomeSummaryDetailModel, MastercardInterchangeIncomeSummaryModel>>(
          `${API_ROOT}/reporthub/reports/mastercardinterchangeincomesummary`,
          reportRequest
      );
      return response;
  },

  exportMastercardInterchangeIncomeSummary: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post(
          `${API_ROOT}/reporthub/reports/mastercardinterchangeincomesummary/export`,
          reportRequest,
          {
              headers: {
                  Accept: "text/csv",
              },
              responseType: "blob",
          }
      );
      return response;
  },

  getCrossBinTransferSummary: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post<Result<CrossBinTransferSummaryModel>>(
          `${API_ROOT}/reporthub/reports/crossbintransfersummary`,
          reportRequest
      );
      return response;
  },

  exportCrossBinTransferSummary: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post(
          `${API_ROOT}/reporthub/reports/crossbintransfersummary/export`,
          reportRequest,
          {
              headers: {
                  Accept: "text/csv",
              },
              responseType: "blob",
          }
      );
      return response;
  },

  getCrossBinTransferDetail: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post<ReportResult<CrossBinTransferDetailModel, CrossBinTransferDetailSummaryModel>>(
          `${API_ROOT}/reporthub/reports/crossbintransferdetail`,
          reportRequest
      );
      return response;
  },

  exportCrossBinTransferDetail: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post(
          `${API_ROOT}/reporthub/reports/crossbintransferdetail/export`,
          reportRequest,
          {
              headers: {
                  Accept: "text/csv",
              },
              responseType: "blob",
          }
      );
      return response;
  },

  getDeclinedAuthorizationRequest: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post<Result<DeclinedAuthorizationRequestModel>>(
          `${API_ROOT}/reporthub/reports/declinedauthorizationrequest`,
          reportRequest
      );
      return response;
  },

  exportDeclinedAuthorizationRequest: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post(
          `${API_ROOT}/reporthub/reports/declinedauthorizationrequest/export`,
          reportRequest,
          {
              headers: {
                  Accept: "text/csv",
              },
              responseType: "blob",
          }
      );
      return response;
  },


  getMonthlyDeclinedTransactions: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post<Result<MonthlyDeclinedTransactionsModel>>(
          `${API_ROOT}/reporthub/reports/monthlydeclinedtransactions`,
          reportRequest
      );
      return response;
  },

  exportMonthlyDeclinedTransactions: async (
      reportRequest: ReportRequest
  ) => {
      const response = await api.post(
          `${API_ROOT}/reporthub/reports/monthlydeclinedtransactions/export`,
          reportRequest,
          {
              headers: {
                  Accept: "text/csv",
              },
              responseType: "blob",
          }
      );
      return response;
  },
};
